<template>
  <div>
    <div class="flap" v-for="flapSection in flapSections" :key="flapSection.id">
        <div class="background--linear">
          <section-tabHead inverse>{{flapSection.title}}</section-tabHead>
          <div class="flap__info container" v-for="(info,index) in flapSection.infoBox" :key="index">
            <img :src="info.image" alt="" class="img-fluid">
            <div class="flap__details">
              <h4 class="flap__title">{{info.subtitle}}</h4>
              <p class="flap__para">
                {{info.paragraph}}
              </p>
            </div>
          </div>
        </div>
    </div>
  </div>
</template>
<script>
import TabHead from "../Shared/TabHead";
import triangle1 from '../../assets/image/about/triangle-1.png';
import triangle2 from '../../assets/image/about/triangle-2.png';
import triangle3 from '../../assets/image/about/triangle-3.png';
import triangle4 from '../../assets/image/about/triangle-4.png';
import triangle5 from '../../assets/image/about/triangle-5.png';

export default {
  data(){
    return {
      flapSections:[
        {
          id:1,
          title:'Live Practicals',
          infoBox:[
            {
              image: triangle1,
              subtitle:'4 REAL-LIFE PROJECTS',
              paragraph:'KNOW YOUR PURPOSE and become accountable for the GOALS you set in 4 of your own real-life projects across BUSINESS, FAMILY, DREAM and HAVE-TO-DO areas.'
            }
          ]
        },
        {
          id:2,
          title:'IMPLEMENTATION',
          infoBox:[
            {
              image: triangle2,
              subtitle:'UNLEARN UNPRODUCTIVE HABITS',
              paragraph:'Unlearn old habits of dealing with failures arising out of internal conditioning and external circumstances. Cut through the layers of reasons and excuses every time something doesn’t go your way.'
            },
            {
              image: triangle3,
              subtitle:'SWITCH FROM KNOWING TO DOING',
              paragraph:'Apply the LAWS OF PRODUCTIVITY along with the knowledge you already have to plan every action you need to take to achieve those Goals.'
            }
          ]
        },
        {
          id:3,
          title:'HAND-HOLDING',
          infoBox:[
            {
              image: triangle4,
              subtitle:'PERSONAL HAND-HOLDING',
              paragraph:'A Personal Consultant will hand-hold you almost on a daily basis for executing your weekly plan.'
            },
            {
              image: triangle5,
              subtitle:'DEVELOP MILLION DOLLAR HABITS',
              paragraph:'Build Productive Habits to master TIME, FOCUS, CLARITY AND REALITY in simple & doable ways to produce Tangible Results every week. '
            }
          ]
        }
      ]
    }
  },
  components:{
    "section-tabHead": TabHead
  }
}
</script>
<style scoped>
.flap{
  margin-bottom: 52px;
}

.flap__image{
  background-image: url('../../assets/image/about/flap.png');
  height: 76px;
  width: 100%;
  background-repeat: no-repeat;
  background-position: top center;
  display: flex;
  align-items: center;
  justify-content: center;
}

.flap__text{
  text-align: center;
  font-family: 'Seravek-Medium';
  font-size: 32px;
  color: var(--secondary-color);
  text-transform: uppercase;
  margin-bottom:0 ;
}

.flap__info{
  display: flex;
  align-items: center;
  padding:26px 0;
}

.flap__title{
  font-family: 'Seravek-Medium';
  font-size: 28px;
  line-height: 29px;
  color:var(--primary-color);
  text-transform: uppercase;
  margin-bottom: 11px;
}

.flap__para{
  font-family: 'Seravek-Light';
  font-size: 20px;
  line-height: 30px;
  color: var(--text-color);
}

.flap__details{
  margin-left: 97px;
}

/* Mobiles (Portrait) */
@media (min-width: 320px) and (max-width: 480px) {
  .flap__info{
    flex-direction: column;
  }

  .flap {
    margin-bottom: 35px;
  }

  .flap__details{
    text-align: center;
    margin: 0 15px;
  }

  .flap__title{
    margin:10px 0;
  }

  .flap__para{
    font-size: 19px;
    line-height: 24px;
  }
}

/* Low Resolution Tablets, Mobiles (Landscape) */
@media (min-width: 481px) and (max-width: 767px) {
  .flap__para{
    font-size: 19px;
    line-height: 24px;
  }
  .flap__title{
    padding:0;
    font-size:22px !important;
  }
  .flap__details{
    margin-left: 50px;
}
}
/* Tablets, Ipads (portrait) */
@media (min-width: 768px) and (max-width: 1024px) {
  
  .flap__title{
    padding:0;
  }
  .flap__details{
    margin-left: 50px;
  }
  
}
</style>